export default {
  getDepartament: state => state.departament,
  getAgents: state => state.agents,
}
